'use strict';

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

module.exports = function (_ref) {
  var keychain = _ref.keychain;
  return withTimeoutOption(function (name, password) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return keychain.exportKey(name, password, options);
  });
};